<template>
  <v-container>
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->

    <section>
      <v-row no-gutters justify="center">
        <v-col class="white--text my-auto" align="center" cols="12" md="5">
          <h1 class="display-2 font-weight-medium">
            Make Your Business More Profitable
          </h1>
          <v-divider vertical></v-divider>
          <p class="white--text subtitle-1">
            <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam
            assumenda ea quo cupiditate facere deleniti fuga officia. Lorem
            ipsum dolor sit amet consectetur adipisicing elit. Laboriosam
            assumenda ea quo cupiditate facere deleniti fuga officia.  -->
            Just as peaple cannot live without eating, so abusiness cannot live
            without profit. Profit is not something to add on at the end, it is
            something to plane for in the beginning. To make good plane you need
            profitional accountant and this system is the next level of human
            accountant.
          </p>
        </v-col>
        <v-col md="7">
          <v-card flat color="primary">
            <v-img contain src="../assets/imags/barchart.svg"></v-img>
          </v-card>
        </v-col>
      </v-row>
    </section>

    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    // HelloWorld,
  },
  mounted() {},
};
</script>
